import { ApiSliceParams } from "../interfaces";
import { makeCalendar } from "./calendar";
import { makeExternal } from "./external";
import { makeGroup } from "./group";
import { makePreliminary } from "./preliminary";
import { makeReport } from "./report";
import { makeTrack } from "./track";

export const makeTime = ({ connection, company }: ApiSliceParams) => {
    const calendar = makeCalendar({ connection, company });
    const external = makeExternal({ connection, company });
    const group = makeGroup({ connection, company });
    const report = makeReport({ connection, company });
    const track = makeTrack({ connection, company });
    const preliminary = makePreliminary({ connection, company });

    return {
        calendar,
        external,
        group,
        report,
        track,
        preliminary,
    };
};
